import { useState, useEffect } from 'react';
import api from '../services/api';
import Sidebar from '../components/Sidebar';

export default function Reembolsos() {
  const [custos, setCustos] = useState([]);
  const [filtroCliente, setFiltroCliente] = useState('');
  const [filtroReembolsado, setFiltroReembolsado] = useState('');
  const [filtroCobrado, setFiltroCobrado] = useState('');

  useEffect(() => { carregar(); }, []);

  async function carregar() {
    const res = await api.get('/atividades/todos-custos');
    setCustos(res.data);
  }

  async function toggleReembolsado(custo) {
    await api.put(`/atividades/${custo.atividade_id}/custos/${custo.id}`, {
      ...custo,
      reembolsado: !custo.reembolsado,
      data_cobranca: custo.data_cobranca || null,
    });
    carregar();
  }

  function formatarData(dt) {
    if (!dt) return '—';
    return new Date(dt + 'T12:00:00').toLocaleDateString('pt-BR');
  }

  const filtrados = custos.filter(c => {
    if (filtroCliente && !c.cliente_nome.toLowerCase().includes(filtroCliente.toLowerCase())) return false;
    if (filtroReembolsado === 'sim' && !c.reembolsado) return false;
    if (filtroReembolsado === 'nao' && c.reembolsado) return false;
    if (filtroCobrado === 'sim' && !c.cobrado_cliente) return false;
    if (filtroCobrado === 'nao' && c.cobrado_cliente) return false;
    return true;
  });

  const totalGeral = filtrados.reduce((acc, c) => acc + parseFloat(c.valor || 0), 0);
  const totalNaoReembolsado = filtrados.filter(c => !c.reembolsado).reduce((acc, c) => acc + parseFloat(c.valor || 0), 0);

  return (
    <div style={styles.container}>
      <Sidebar />
      <div style={styles.conteudo}>
        <div style={styles.header}>
          <h1 style={styles.titulo}>Reembolsos</h1>
          <div style={{ display: 'flex', gap: '16px' }}>
            <div style={styles.card}>
              <span style={styles.cardLabel}>Total geral</span>
              <span style={styles.cardValor}>R$ {totalGeral.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
            </div>
            <div style={{ ...styles.card, borderColor: '#e53935' }}>
              <span style={styles.cardLabel}>Pendente reembolso</span>
              <span style={{ ...styles.cardValor, color: '#e53935' }}>R$ {totalNaoReembolsado.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
            </div>
          </div>
        </div>

        <div style={styles.filtros}>
          <input style={styles.filtroInput} placeholder="Buscar por cliente..." value={filtroCliente} onChange={e => setFiltroCliente(e.target.value)} />
          <select style={styles.filtroInput} value={filtroReembolsado} onChange={e => setFiltroReembolsado(e.target.value)}>
            <option value="">Todos — reembolso</option>
            <option value="sim">Reembolsado</option>
            <option value="nao">Não reembolsado</option>
          </select>
          <select style={styles.filtroInput} value={filtroCobrado} onChange={e => setFiltroCobrado(e.target.value)}>
            <option value="">Todos — cobrança</option>
            <option value="sim">Cobrado do cliente</option>
            <option value="nao">Não cobrado</option>
          </select>
        </div>

        <table style={styles.tabela}>
          <thead>
            <tr>
              {['Cliente', 'Atividade', 'Serviço', 'Data', 'Local', 'Pago por', 'Valor', 'Cobrado', 'Reembolsado', ''].map(h => (
                <th key={h} style={styles.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtrados.map(c => (
              <tr key={c.id} style={{ ...styles.tr, ...(c.reembolsado ? { opacity: 0.6 } : {}) }}>
                <td style={styles.td}>{c.cliente_nome}</td>
                <td style={{ ...styles.td, fontSize: '12px', color: '#888' }}>#{c.atividade_id}</td>
                <td style={styles.td}>{c.servico}</td>
                <td style={{ ...styles.td, fontSize: '12px' }}>{formatarData(c.data_despesa)}</td>
                <td style={styles.td}>{c.local || '-'}</td>
                <td style={styles.td}>{c.pago_por || '-'}</td>
                <td style={{ ...styles.td, fontWeight: '600', color: '#e53935' }}>
                  R$ {parseFloat(c.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </td>
                <td style={styles.td}>
                  {c.cobrado_cliente
                    ? <span style={{ color: '#1976d2', fontSize: '12px' }}>✓ Sim</span>
                    : <span style={{ color: '#888', fontSize: '12px' }}>Não</span>}
                </td>
                <td style={styles.td}>
                  {c.reembolsado
                    ? <span style={{ color: '#388e3c', fontSize: '12px' }}>✓ Sim</span>
                    : <span style={{ color: '#f57c00', fontSize: '12px' }}>Pendente</span>}
                </td>
                <td style={styles.td}>
                  <button
                    style={{ backgroundColor: 'transparent', color: c.reembolsado ? '#888' : '#388e3c', border: `1px solid ${c.reembolsado ? '#ddd' : '#388e3c'}`, padding: '4px 10px', borderRadius: '4px', fontSize: '11px', cursor: 'pointer' }}
                    onClick={() => toggleReembolsado(c)}
                  >
                    {c.reembolsado ? 'Desfazer' : 'Marcar reembolsado'}
                  </button>
                </td>
              </tr>
            ))}
            {filtrados.length === 0 && (
              <tr>
                <td colSpan={10} style={{ ...styles.td, textAlign: 'center', color: '#aaa', padding: '2rem' }}>
                  Nenhum lançamento encontrado
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const styles = {
  container: { display: 'flex', height: '100vh', overflow: 'hidden', backgroundColor: '#f0f2f5' },
  conteudo: { flex: 1, padding: '2.5rem', overflowY: 'auto' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem' },
  titulo: { fontSize: '22px', color: '#1a1a2e', margin: 0 },
  card: { backgroundColor: '#fff', border: '1px solid #e0e0e0', borderRadius: '8px', padding: '10px 20px', textAlign: 'center' },
  cardLabel: { display: 'block', fontSize: '11px', color: '#888', marginBottom: '4px' },
  cardValor: { display: 'block', fontSize: '18px', fontWeight: '600', color: '#1a1a2e' },
  filtros: { display: 'flex', gap: '10px', marginBottom: '1.5rem', flexWrap: 'wrap' },
  filtroInput: { padding: '8px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '13px', minWidth: '200px' },
  tabela: { width: '100%', borderCollapse: 'collapse', backgroundColor: '#fff', borderRadius: '8px', overflow: 'hidden' },
  th: { padding: '10px 14px', textAlign: 'left', fontSize: '11px', color: '#888', borderBottom: '1px solid #f0f0f0', fontWeight: '500' },
  tr: { borderBottom: '1px solid #f0f0f0' },
  td: { padding: '10px 14px', fontSize: '13px', color: '#333' },
};